<template>
  <div v-if="valueIsDefined">
    <span v-if="selectAll">{{ selectAll }}</span>
    <Component
      :is="component"
      v-else
      :status="value"
    />
  </div>
</template>

<script>

import Vue from 'vue'
import i18n from '@/lang/i18n'

export default Vue.extend({
    name: 'CommonSetFilterRenderer',
    computed: {
        valueIsDefined() {
            return this.params.value !== undefined
        },
        value() {
            const valueInStates = this.states.find((state) => state.code === this.params.value)
            return valueInStates || this.params.value
        },
        states() {
            return this.params.states
        },
        component() {
            return this.params.component
        },
        selectAll() {
            return this.params.value === i18n.t('component.agGrid.selectAll')
                ? this.params.value : null
        }
    }
})

</script>
